var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},_vm._l((_vm.faqs),function(item){return _c('el-collapse-item',{key:item?.id,attrs:{"title":item?.header,"name":item?.id}},[_c('div',[_vm._v(" "+_vm._s(item?.description)+" ")])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }